import { color } from "html2canvas/dist/types/css/types/color"
import { COLORS } from "../../../../utils/colors"


export const useSessionSummaryStyles = () => {
    return {
        modal: {
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '40vw',
            height: '98vh',
            minWidth: '40%',
            minHeight: '40%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: '4',
            borderRadius: '1rem',
            paddingBottom: '2.5rem',
           
        },
        reciptModal: {
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            minWidth: '700px',
            width: 'auto',
            height: 'auto',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: '1rem',
            padding: '4rem',
            paddingTop: '1rem',
            paddingBottom: '6.5rem'
        },
        bookingModal: {
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '700px',
          height: '800px',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: '1rem',
          padding: '4rem',
          paddingTop: '1rem',
          paddingBottom: '6.5rem'

        },
        detailsInput: {
          '& .MuiOutlinedInput-root': {
            height: '5.5rem',
            borderRadius: '15px',
            fontSize: '11px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: COLORS.BLACK,
          },
          },
          '& .MuiInputLabel-root': {
            fontWeight: '500',
            lineHeight: '10px',
            fontSize: '11px',
            color: COLORS.MEDIUM_GRAY,
          },
        },

        input: {
          '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
        backgroundColor: 'white',
        fontSize: '11px',
        fontWeight: '500',
        height: '2.3rem',
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
        borderColor: COLORS.BLACK,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: COLORS.BLACK,
      },
        '& fieldset': {
          borderRadius: '25px',
        },
        '&:hover fieldset': {
          borderColor: COLORS.DARK_GREY,
        },
        '&.Mui-focused fieldset': {
          borderColor: COLORS.PRIMARY,
        },
        '&.Mui-error fieldset': {
          borderColor: COLORS.RED,
        },
      },
      '& .MuiInputLabel-root': {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        lineHeight: '11.5px',
        textAlign: 'center',
        fontSize: '11px',
        height: '29px',
        top: '-9px',
        paddingBottom: '2.5px',
        color: COLORS.MEDIUM_GRAY,
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: COLORS.PRIMARY,
      },
      '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
        transform: 'translate(12px, 20%) scale(1)',
      },
        },
        selectInput: {
          '& .MuiOutlinedInput-root': {
        borderRadius: '50px',
        backgroundColor: 'white',
        fontSize: '11px',
        fontWeight: '500',
        height: '2.3rem',
        fontFamily: ['Montserrat', 'sans-serif'].join(','),
        borderColor: COLORS.BLACK,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: COLORS.BLACK,
      },
        '& fieldset': {
          borderRadius: '25px',
        },
        '&:hover fieldset': {
          borderColor: COLORS.DARK_GREY,
        },
        '&.Mui-focused fieldset': {
          borderColor: COLORS.PRIMARY,
        },
        '&.Mui-error fieldset': {
          borderColor: COLORS.RED,
        },
      },
      '& .MuiInputLabel-root': {
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        lineHeight: '11.5px',
        textAlign: 'center',
        fontSize: '11px',
        height: '29px',
        paddingBottom: '2.5px',
        color: COLORS.MEDIUM_GRAY,
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: COLORS.PRIMARY,
      },
      '&.MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
        transform: 'translate(12px, 20%) scale(1)',
      },
        },
        container: {
          width: 'auto !important',
          marginLeft: '0px',
          borderBottom: '1px solid lightgrey',
          marginBottom: '1rem',
          paddingBottom: '1.5rem',
          display: 'flex',
          justifyContent: 'center',
          paddingTop: '1rem',
          paddingLeft: '2rem'
        },
        containerBottom: {
          marginTop: '1rem',
          width: 'auto !important',
          marginLeft: '0px',
          borderBottom: '0px solid lightgrey',
          
          display: 'flex',
          justifyContent: 'center',
          padding: '2rem',
          paddingTop: '1rem',
          paddingBottom: '0rem',
        },
        containerDescription: {
      
          width: 'auto !important',
          marginLeft: '0px',
          borderBottom: '0px solid lightgrey',
          
          display: 'flex',
          justifyContent: 'center',
          padding: '2rem',
          paddingTop: '1rem',
          paddingBottom: '0rem',
        },
        title: {
            fontWeight: 800,
            fontSize: '1.1rem',
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
        },
        futureTitle: {
          fontWeight: 800,
          fontSize: '1.1rem',
          flexGrow: 1,
          display: 'flex',
          justifyContent: 'center',
        },
        header: {
            display: 'flex', 
            justifyContent: 'center', 
            height: '3rem', 
            alignItems: 'center',
            marginBottom: '1.5rem',
            paddingLeft: '9rem'
        },
        reciptHeader: {
          display: 'flex', 
          justifyContent: 'space-between !important', 
          width: '100%',
          height: '3rem', 
          alignItems: 'center',
      },
        button: {
            fontWeight: 200,
            whiteSpace: 'nowrap',
            backgroundColor: COLORS.PRIMARY,
            fontSize: '0.75rem',
            marginRight: '0',
            padding: '.3125rem 1rem',
            color: '#fff',
            '&: hover': {
            backgroundColor: COLORS.PRIMARY,
            }
        },
        subHeading: {
          fontSize: '0.75',
          paddingBottom: '1.5rem',
          paddingLeft: '1rem',
          color: COLORS.BLACK,
          fontWeight: 500,
         
        },
        detailSubHeading: {
          fontSize: '0.75',
          paddingLeft: '1rem',
          color: COLORS.BLACK,
          fontWeight: 500,


        },
        HomeOwnerSubHeading: {
          fontSize: '0.75',
          paddingLeft: '2rem',
          color: COLORS.BLACK,
          fontWeight: 500,
          marginBottom: '1rem'
        },
        detailsHeader: {
          width: '100%',
          marginLeft:'2rem',
          marginRight:'2rem',
           marginTop:'1rem',
           display: 'flex',
           marginBottom: '0.5rem',
           paddingBottom: '1rem'
        },
        bookingText: {
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.85rem',
          marginLeft: '0.6rem'
        },
        gridItem: {
          paddingBottom: '1rem'
        },
        confirmation: {
          textAlign: 'center',
          fontSize: '11px',
          marginBottom: '1.8rem',
        },
        printConf: {
          textAlign: 'center',
          fontSize: '10px',
          marginBottom: '0.5rem',
          textDecoration: 'underline',
          cursor: 'pointer'
        },
        information: {
          fontSize: '0.85rem',
          display:'flex',
          alignItems: 'center',
          color: COLORS.BLACK,
          fontWeight: 400,
        },
        homeInfoText: {
          fontSize: '0.85rem',
        },
        sectionTitle: {
          fontWeight: '500',
          fontSize: '0.85rem',
        },
        iconSpace: {
          Width: '100%',
          marginLeft: '1rem',
          fontSize: '15px'
        },
        bookingIcon: {
          marginRight: '0.6rem',
          },
        detailsIcon: {
          fontSize: '0.8rem',
          color: COLORS.BLACK,
          fontWeight: 400,
          display: 'flex',
          alignItems: 'flexStart',
        },
        address: {
          paddingLeft: '1.9rem',
          fontSize: '0.85rem',
          color: COLORS.BLACK,
          textDecoration: 'underline',
        },
        insepctionButton: {
          backgroundImage: 'linear-gradient(263deg, #ff6e00 43%, #ff9e54 91%)',
          color: 'white',
          fontSize: '0.8rem',
          borderRadius: '1rem',
          textTransform: 'none',
          paddingLeft: '0.7rem',
          paddingRight: '0.7rem',
        },
        modalContainer: {
          alignItems: 'center',
          padding: '0.5rem',
          paddingBottom: '0',
          borderRadius: '1rem',
          display: 'flex',
          width: '100%'
        },
        connectionTest: {
          alignItems: 'center',
          padding: '0.5rem',
          paddingBottom: '0',
          borderRadius: '1rem',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          paddingLeft: '2rem',
          paddingRight: '2rem',
          marginBottom: '1rem'
        },
        connectionTestText: {
          textDecoration: 'underline',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.85rem',
        },
        enterSessionButton: {
            backgroundColor: '#0b1339',
            textTransform: 'none',
            color: '#fff',
            borderRadius: '2rem',
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            fontSize: '0.8rem',
            marginLeft: '1.5rem',
            marginTop: '1rem',
            marginBottom: '1rem',
            '&:hover': {
              backgroundColor: '#0b1339'
            }
        },
        viewReportButton: {
          backgroundColor: '#fff',
          border: '1px solid #0b1339',
          textTransform: 'none',
          color: '#0b1339',
          borderRadius: '2rem',
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
          fontSize: '0.8rem',
          marginLeft: '1.5rem',
          marginTop: '1rem',
          marginBottom: '1rem',
          '&:hover': {
            backgroundColor: '#fff'
          }
      },
        modalHeading: {
          fontWeight: '500',
          fontSize: '13px',
          marginRight: '1.5rem',
          marginLeft: '1.5rem'
        },
        actionButtonCon: {
          display: 'flex',
          justifyContent: 'flex-end',
          marginRight: '1rem',
        },
        actionButton: {
          border: 'solid 0.5px #dcdcdc',
          marginLeft: '0.4rem'
        },
        iconSize: {
          display: 'flex',
          justifyContent: 'flex-end',
          width: '1.25rem',
          height: 'auto'
        },
        actionCollection: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '1rem'
        },
        markComplete: {
          display: 'flex',
          fontSize: '0.8rem',
          textDecoration: 'underline',
          cursor: 'pointer',
          color: '#04970b',
          textTransform: 'none',
        },
        rescheduleButton: {
          fontSize: '0.8rem',
          textDecoration: 'underline',
          cursor: 'pointer',
          color: '#f57c00',
          textTransform: 'none',
        },
        cancelButton: {
          fontSize: '0.8rem',
          paddingLeft: '1rem',
          textDecoration: 'underline',
          cursor: 'pointer',
          textTransform: 'none',
          color: '#dc0808',
        }


  }
  }